import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TcPage } from '@tc/core';
import { IPageState } from '@tc/store';

@Component({
  selector: 'app-organismes-page',
  templateUrl: './organismes-page.component.html',
  styleUrls: ['./organismes-page.component.scss'],
})
export class OrganismesPageComponent extends TcPage implements OnInit {
  constructor(store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'organismes-page.title',
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }
}
